export default __webpack_public_path__ + "static/media/transparency.014bfdae.jpg";